import './lib/diag.ts';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';
import './styles.css';
import { Landing } from './ui/Landing.tsx';
import { StudioPage } from './ui/StudioPage.tsx';
import { FilesPage } from './ui/FilesPage.tsx';
import { AccountPage } from './ui/AccountPage.tsx';
import { LocalPage } from './ui/LocalPage.tsx';
import { AdminFeedbackPage } from './ui/AdminFeedbackPage.tsx';
import { Feedback } from './ui/Feedback.tsx';

function App() {
  const path = location.pathname;
  const key = new URLSearchParams(location.search).get('k') ?? '';
  const files = /^\/s\/([^/]+)\/files\/?$/.exec(path);
  if (files) return <FilesPage studioId={files[1]} studioKey={key} />;
  const studio = /^\/s\/([^/]+)\/?$/.exec(path);
  if (studio) return <StudioPage studioId={studio[1]} studioKey={key} />;
  if (/^\/account\/?$/.test(path)) return <AccountPage />;
  if (/^\/local\/?$/.test(path)) return <LocalPage />;
  if (/^\/admin\/feedback\/?$/.test(path)) return <AdminFeedbackPage />;
  return <Landing />;
}

createRoot(document.getElementById('root')!).render(
  <>
    <App />
    <Feedback />
  </>,
);
